import * as R from 'ramda';

export default {
    methods: {
        formatBusinessHours(data) {
            const items = [
                { active: false, fromTimeValue: false, toTimeValue: false, day: 'generic.monday', fromTime: '00:00', toTime: '00:00' },
                { active: false, fromTimeValue: false, toTimeValue: false, day: 'generic.tuesday', fromTime: '00:00', toTime: '00:00' },
                { active: false, fromTimeValue: false, toTimeValue: false, day: 'generic.wednesday', fromTime: '00:00', toTime: '00:00' },
                { active: false, fromTimeValue: false, toTimeValue: false, day: 'generic.thursday', fromTime: '00:00', toTime: '00:00' },
                { active: false, fromTimeValue: false, toTimeValue: false, day: 'generic.friday', fromTime: '00:00', toTime: '00:00' },
                { active: false, fromTimeValue: false, toTimeValue: false, day: 'generic.saturday', fromTime: '00:00', toTime: '00:00' },
                { active: false, fromTimeValue: false, toTimeValue: false, day: 'generic.sunday', fromTime: '00:00', toTime: '00:00' },
            ];
            if ('hours' in data) {
                for (let index = 0; index < data.hours.length; index++) {
                    const item = {};
                    switch (data.hours[index].week_day) {
                        case 1:
                            item.day = 'generic.monday';
                            item.active = true;
                            item.fromTimeValue = false;
                            item.toTimeValue = false;
                            item.fromTime = data.hours[index].from_time;
                            item.toTime = data.hours[index].to_time;
                            this.updateDay(item, items);
                            break;
                        case 2:
                            item.day = 'generic.tuesday';
                            item.active = true;
                            item.fromTimeValue = false;
                            item.toTimeValue = false;
                            item.fromTime = data.hours[index].from_time;
                            item.toTime = data.hours[index].to_time;
                            this.updateDay(item, items);
                            break;
                        case 3:
                            item.day = 'generic.wednesday';
                            item.active = true;
                            item.fromTimeValue = false;
                            item.toTimeValue = false;
                            item.fromTime = data.hours[index].from_time;
                            item.toTime = data.hours[index].to_time;
                            this.updateDay(item, items);
                            break;
                        case 4:
                            item.day = 'generic.thursday';
                            item.active = true;
                            item.fromTimeValue = false;
                            item.toTimeValue = false;
                            item.fromTime = data.hours[index].from_time;
                            item.toTime = data.hours[index].to_time;
                            this.updateDay(item, items);
                            break;
                        case 5:
                            item.day = 'generic.friday';
                            item.active = true;
                            item.fromTimeValue = false;
                            item.toTimeValue = false;
                            item.fromTime = data.hours[index].from_time;
                            item.toTime = data.hours[index].to_time;
                            this.updateDay(item, items);
                            break;
                        case 6:
                            item.day = 'generic.saturday';
                            item.active = true;
                            item.fromTimeValue = false;
                            item.toTimeValue = false;
                            item.fromTime = data.hours[index].from_time;
                            item.toTime = data.hours[index].to_time;
                            this.updateDay(item, items);
                            break;
                        case 7:
                            item.day = 'generic.sunday';
                            item.active = true;
                            item.fromTimeValue = false;
                            item.toTimeValue = false;
                            item.fromTime = data.hours[index].from_time;
                            item.toTime = data.hours[index].to_time;
                            this.updateDay(item, items);
                            break;
                    }
                }
            } else {
                R.forEach(value => {
                    value.active = true;
                }, items);
            }
            return items;
        },
        updateDay(item, items) {
            for (let index = 0; index < items.length; index++) {
                if (items[index].day === item.day) {
                    items[index] = item;
                }
            }
        },
        deserializeBusiness(business) {
            if (business.menus === null) {
                delete business.menus;
            }
            if (business.menus === undefined) {
                business.menus = [];
            }
            delete business.profile_picture;
            business.tags = business.tags.map(businessTag => businessTag.id);
            business.service_options = business.service_options.map(businessServiceOption => businessServiceOption.id);
            business.facility_options = business.facility_options.map(businessFacilityOption => businessFacilityOption.id);
            business.amenity_options = business.amenity_options.map(businessAmenityOption => businessAmenityOption.id);
            business.parking_options = business.parking_options.map(businessParkingOption => businessParkingOption.id);
            business.payment_options = business.payment_options.map(businessPaymentOption => businessPaymentOption.id);
            return business;
        },
        clearBusinessOptions(options) {
            options.forEach(option => {
                option.selected = false;
            });
            return options;
        },
        filterBusinessOptions(businessOptionIds, options) {
            businessOptionIds.forEach(businessOptionId => {
                options.forEach(option => {
                    if (option.id === businessOptionId) {
                        option.selected = true;
                    }
                });
            });
            return options;
        },
        updateOption(businessOptions, option) {
            if (option.selected) {
                businessOptions.push(option);
            } else {
                businessOptions.splice(
                    businessOptions.findIndex(item => item.id === option.id),
                    1,
                );
            }
        },
    },
    filters: {
        truncate(text, length, sign) {
            if (text !== null && text !== undefined) {
                sign = sign || '...';
                const a = text.length > length ? text.slice(0, length) + sign : text;
                return a;
            }
            return '';
        },
        displayLang(data, attribute, lang) {
            switch (lang) {
                case 'en':
                    attribute += '_en';
                    break;
                case 'gr':
                    attribute += '_gr';
                    break;
                case null:
                    attribute += '_en';
                    break;
                default:
                    attribute += '_en';
            }
            return data[`${attribute}`];
        },
        // formatNumber(value) {
        //     return numeral(value).format('0,0');
        // },
        // formatLargeNumber(value) {
        //     if (value >= 10000) {
        //         return numeral(value).format('0.00a');
        //     }

        //     return numeral(value).format('0,0');
        // },
        // formatPercent(value) {
        //     return numeral(value).format('+0.0%');
        // },
        // formatPercentage(value) {
        //     // eslint-disable-next-line
        //     if (isNaN(value) || !isFinite(value)) return '-';

        //     return numeral(value).format('0.0%');
        // },
        // formatDifference(current, previous) {
        //     if (previous === 0) {
        //         return '';
        //     }

        //     return numeral(Math.abs(current - previous) / previous).format('0%');
        // },
    },
};
